export default "__VITE_ASSET__CXcUl7yh__"